import { useMemo } from 'react';

import { findCenterRegion } from '@garnish/location';

import type { OrderStatusMapProps } from '../../types';

export const useRegion = (props: OrderStatusMapProps) => {
  const {
    locationLatitude,
    locationLongitude,
    customerLatitude,
    customerLongitude,
    deliveryAddressLatitude,
    deliveryAddressLongitude,
    courierLatitude,
    courierLongitude,
  } = props;

  return useMemo(() => {
    const center = findCenterRegion(
      [
        { lat: locationLatitude ?? 0, lng: locationLongitude ?? 0 },
        { lat: customerLatitude ?? 0, lng: customerLongitude ?? 0 },
        {
          lat: deliveryAddressLatitude ?? 0,
          lng: deliveryAddressLongitude ?? 0,
        },
        { lat: courierLatitude ?? 0, lng: courierLongitude ?? 0 },
      ],
      { width: 300, height: 200 },
    );
    const centerZoom = center.zoom ? center.zoom - 1 : 21;
    const zoom = Math.min(centerZoom, 16);

    return { ...center, zoom };
  }, [
    locationLatitude,
    locationLongitude,
    customerLatitude,
    customerLongitude,
    deliveryAddressLatitude,
    deliveryAddressLongitude,
    courierLatitude,
    courierLongitude,
  ]);
};
